import React from 'react';
import { number, string, arrayOf, shape, bool } from 'prop-types';
import { LinearProgress } from '../../atoms';
import { Review } from '../../molecules';
import { Container, Main, Content, Score, Description, Line } from './review-characteristics.styles';
import Text from '../../atoms/Text';

function ReviewCharacteristics({
  average,
  count: total,
  characteristics,
  showScoreDesc
}) {
  const desc = total > 1 ? `${total} avaliações` : `${total} avaliação`;
  return /*#__PURE__*/React.createElement(Container, {
    showScoreDesc: showScoreDesc
  }, showScoreDesc && /*#__PURE__*/React.createElement(Main, null, /*#__PURE__*/React.createElement(Score, {
    "data-testid": "stat-score"
  }, /*#__PURE__*/React.createElement("span", null, "Nota:"), ` ${average.toFixed(1)}`), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Review, {
    score: average,
    width: "20px",
    height: "20px"
  }), /*#__PURE__*/React.createElement(Description, {
    "data-testid": "stat-desc"
  }, desc))), /*#__PURE__*/React.createElement("ul", null, characteristics == null ? void 0 : characteristics.map(item => /*#__PURE__*/React.createElement(Line, {
    key: item.label
  }, /*#__PURE__*/React.createElement(Text, null, item.label), /*#__PURE__*/React.createElement(LinearProgress, {
    height: "8px",
    color: "#0086ff",
    value: item.value,
    max: 5
  }), /*#__PURE__*/React.createElement(Text, null, item.value.toFixed(1))))));
}

ReviewCharacteristics.defaultProps = {
  average: 0,
  count: 0,
  characteristics: [],
  showScoreDesc: true
};
process.env.NODE_ENV !== "production" ? ReviewCharacteristics.propTypes = {
  average: number,
  count: number,
  characteristics: arrayOf(shape({
    label: string,
    value: number
  })),
  showScoreDesc: bool
} : void 0;
export default ReviewCharacteristics;